import request from '@/utils/http';

// 发票上传，识别、验真
export const upload = (data) => {
    return request({
        url: `/api-bms-web/efApInvoiceHeader/invoiceUpload`,
        method: 'post',
        data
    });
};

// 仅发票上传,无识别与验真
export const onlyUpload = (data) => {
    return request({
        url: `/api-bms-web/efApInvoiceHeader/onlyInvoiceUpload`,
        method: 'post',
        data
    });
};

export const salesUpload = (data) => {
    return request({
        url: `/api-bms-web/efApInvoiceHeader/invoiceSalesUpload`,
        method: 'post',
        data
    });
};

// 发票保存
export const save = (data) => {
    return request({
        url: `/api-bms-web/efApInvoiceHeader/invoiceSave`,
        method: 'post',
        data: data
    });
};
